import { useEffect, useState } from 'react';
import { usePOS } from '../context/POSContext.js';
import CategorySidebar from './CategorySidebar.js';
import ProductGrid from './ProductGrid.js';
import OrderSummary from './OrderSummary.js';
import TableView from './TableView.js';
import SearchBar from './SearchBar.js';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../feature/authSlice.js';
import { useNavigate } from 'react-router-dom';

function Layout({ children }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { activeCategory, currentOrder, activeTable, setActiveTable, tables } = usePOS();
  const [showTableSelection, setShowTableSelection] = useState(false);
  const { token } = useSelector((state) => state.auth);

  useEffect(() => {
    if (!token) {
      navigate('/');
    }
  }, [token, navigate]);

  const handleTableSelection = (tableId) => {
    setActiveTable(tableId);
    setShowTableSelection(false);
  };

  const handleLogout = () => {
    dispatch(logout());
    navigate('/');
    console.log('User logged out');
  };

  return (
    <div className="flex flex-col h-screen bg-gray-100">
      {/* Top Header */}
      <header className="bg-amber-800 text-white p-4 shadow-md"
      style={{ backgroundColor: '#56adb2' }}>
        <div className="container mx-auto flex justify-between items-center">
          <div className="flex items-center">
         
            <h1 className="text-xl font-bold flex items-center">
             <img src="/logo.png" alt="Logo" className="h-16 w-16 mr-2"/>
              Snack SpongeBob
            </h1>
          </div>
          <div>
         <button
  onClick={() => navigate('/orders')}
  className="text-black px-4 py-2 rounded-md font-medium transition-colors  mr-4"
  style={{ backgroundColor: '#fdf54d' }}
  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#e6e041')}
  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#fdf54d')}
>
  Voir les états des commandes
</button>

            <button
              onClick={() => setShowTableSelection(true)}
         className="text-black px-4 py-2 rounded-md font-medium transition-colors"
  style={{ backgroundColor: '#fdf54d' }}
  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#e6e041')}
  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#fdf54d')}
>
              Sélectionner une table
            </button>
            <button className="ml-4 bg-transparent hover:bg-amber-700 p-2 rounded-full">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
            </button>
            <button
              onClick={handleLogout}
          className="text-black px-4 py-2 rounded-md font-medium transition-colors"
  style={{ backgroundColor: '#fdf54d' }}
  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#e6e041')}
  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#fdf54d')}
>
              Se déconnecter
            </button>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <div className="flex flex-1 overflow-hidden">
        {/* Left Sidebar - Categories */}
        <aside className="bg-amber-900 text-white w-24 flex-shrink-0 flex flex-col items-center" style={{ backgroundColor: '#56adb2' }}>
          <CategorySidebar />
        </aside>

        {/* Main Content Area */}
        <main className="flex-1 flex overflow-hidden">
          <div className="flex-1 p-4 overflow-auto">
            <div className="mb-4">
              <SearchBar />
            </div>
            <ProductGrid />
          </div>

          {/* Right Sidebar - Order Details */}
          <aside className="w-80 bg-white border-l border-gray-200 overflow-auto">
            <OrderSummary />
          </aside>
        </main>
      </div>

      {/* Table Selection Modal */}
      {showTableSelection && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg max-w-3xl w-full max-h-[90vh] overflow-auto">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-bold">Select Table</h2>
              <button
                onClick={() => setShowTableSelection(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <TableView onTableSelect={handleTableSelection} />
          </div>
        </div>
      )}
    </div>
  );
}

export default Layout;
